import { vModelText as _vModelText, createVNode as _createVNode, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "row mb-4" }
const _hoisted_4 = { class: "col-lg-8" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "col-lg-4" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<option value=\"checkBox\">Checkbox</option><option value=\"radioButton\">Radio</option><option value=\"single_select\">Select</option><option value=\"textArea\">Textarea</option><option value=\"textbox\">TextBox</option>", 5)
const _hoisted_13 = { class: "col-lg-1" }
const _hoisted_14 = {
  key: 0,
  class: "col-lg-6"
}
const _hoisted_15 = {
  key: 1,
  class: "col-lg-3"
}
const _hoisted_16 = {
  key: 2,
  class: "col-lg-9"
}
const _hoisted_17 = { class: "col-lg-2" }
const _hoisted_18 = { class: "action-btn" }
const _hoisted_19 = /*#__PURE__*/_createVNode("svg", {
  class: "svg-inline--fa fa-times fa-w-11",
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "times",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 352 512",
  "data-fa-i2svg": ""
}, [
  /*#__PURE__*/_createVNode("path", {
    fill: "currentColor",
    d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
  })
], -1)
const _hoisted_20 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_23 = { class: "form-element-action" }
const _hoisted_24 = { class: "custom-control custom-switch mr-3" }
const _hoisted_25 = { class: "action-wrapper" }
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "far fa-clone" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Duplicate ", -1)
const _hoisted_28 = { class: "action-wrapper" }
const _hoisted_29 = /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Delete ", -1)
const _hoisted_31 = { class: "action-wrapper" }
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("span", { class: "tooltiptxt" }, " Add form New element ", -1)
const _hoisted_34 = {
  key: 0,
  class: "readonly-title"
}
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "list-items-row" }
const _hoisted_37 = { for: "checkddd" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.form.type === 'checkBox')
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (_ctx.form.isActive)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: 
                        _ctx.form.titleError
                          ? 'form-control error-field'
                          : 'form-control'
                      ,
                      placeholder: "Question",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.title = $event))
                    }, null, 2), [
                      [_vModelText, _ctx.form.title]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _withDirectives(_createVNode("select", {
                      class: "form-control custom-select",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.type = $event)),
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedFormElement(_ctx.form)))
                    }, [
                      _hoisted_8
                    ], 544), [
                      [_vModelSelect, _ctx.form.type]
                    ])
                  ])
                ])
              ]),
              _createVNode("div", {
                class: "form-group",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeActiveStatus(_ctx.form)))
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form.options, (options, optionsIndex) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "row checkbox",
                    key: optionsIndex
                  }, [
                    _createVNode("div", _hoisted_13, [
                      _withDirectives(_createVNode("input", {
                        type: "checkbox",
                        id: "checkbox",
                        name: "checkbox1",
                        "onUpdate:modelValue": ($event: any) => (options.selected = $event),
                        value: options.option
                      }, null, 8, ["onUpdate:modelValue", "value"]), [
                        [_vModelCheckbox, options.selected]
                      ])
                    ]),
                    (_ctx.form.metaDataList && _ctx.form.metaDataList.length)
                      ? (_openBlock(), _createBlock("div", _hoisted_14, [
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: 
                            options.optionError
                              ? 'form-control error-field'
                              : 'form-control'
                          ,
                            placeholder: `Option ${optionsIndex + 1}`,
                            "onUpdate:modelValue": ($event: any) => (options.option = $event)
                          }, null, 10, ["placeholder", "onUpdate:modelValue"]), [
                            [_vModelText, options.option]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.form.metaDataList && _ctx.form.metaDataList.length)
                      ? (_openBlock(), _createBlock("div", _hoisted_15, [
                          _withDirectives(_createVNode("select", {
                            class: "form-control custom-select",
                            "onUpdate:modelValue": ($event: any) => (options.metaData = $event),
                            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.selectMetaData && _ctx.selectMetaData(...args)))
                          }, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form.metaDataList, (metaData, metaDataIndex) => {
                              return (_openBlock(), _createBlock("option", {
                                value: metaData,
                                key: metaDataIndex
                              }, _toDisplayString(metaData), 9, ["value"]))
                            }), 128))
                          ], 40, ["onUpdate:modelValue"]), [
                            [_vModelSelect, options.metaData]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.form.metaDataList && !_ctx.form.metaDataList.length)
                      ? (_openBlock(), _createBlock("div", _hoisted_16, [
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: 
                          options.optionError
                            ? 'form-control error-field'
                            : 'form-control'
                        ,
                            placeholder: `Option ${optionsIndex + 1}`,
                            "onUpdate:modelValue": ($event: any) => (options.option = $event)
                          }, null, 10, ["placeholder", "onUpdate:modelValue"]), [
                            [_vModelText, options.option]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_17, [
                      _createVNode("div", _hoisted_18, [
                        _createVNode("button", {
                          type: "button",
                          class: "option-btn",
                          onClick: ($event: any) => (_ctx.deleteSelecedOption(_ctx.form, options))
                        }, [
                          _hoisted_19
                        ], 8, ["onClick"]),
                        (_ctx.form.options && _ctx.form.options.length)
                          ? (_openBlock(), _createBlock("span", _hoisted_20, [
                              (optionsIndex === _ctx.form.options.length - 1)
                                ? (_openBlock(), _createBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "add-btn",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addSelectOptions(_ctx.form)))
                                  }, [
                                    _hoisted_21
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _hoisted_22,
              _createVNode("div", _hoisted_23, [
                _createVNode("div", _hoisted_24, [
                  _withDirectives(_createVNode("input", {
                    type: "checkbox",
                    class: "custom-control-input",
                    id: `customSwitch${_ctx.formIndex}`,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.required = $event))
                  }, null, 8, ["id"]), [
                    [_vModelCheckbox, _ctx.form.required]
                  ]),
                  _createVNode("label", {
                    class: "custom-control-label",
                    for: `customSwitch${_ctx.formIndex}`
                  }, "Required", 8, ["for"])
                ]),
                _createVNode("div", _hoisted_25, [
                  _createVNode("a", {
                    href: "javascript:void(0)",
                    class: "btn",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.duplicateSelectedElement(_ctx.form)))
                  }, [
                    _hoisted_26
                  ]),
                  _hoisted_27
                ]),
                _createVNode("div", _hoisted_28, [
                  _createVNode("a", {
                    href: "javascript:void(0)",
                    class: "btn",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.deleteSelectedElement(_ctx.form)))
                  }, [
                    _hoisted_29
                  ]),
                  _hoisted_30
                ]),
                _createVNode("div", _hoisted_31, [
                  _createVNode("a", {
                    href: "javascript:void(0)",
                    class: "btn add-element-btn",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addElementNew(_ctx.form)))
                  }, [
                    _hoisted_32
                  ]),
                  _hoisted_33
                ])
              ])
            ]))
          : (_openBlock(), _createBlock("div", {
              key: 1,
              class: "readonly checkbox-design",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeActiveStatus(_ctx.form)))
            }, [
              (_ctx.form.title)
                ? (_openBlock(), _createBlock("label", _hoisted_34, _toDisplayString(_ctx.form.title), 1))
                : (_openBlock(), _createBlock("label", _hoisted_35, "Question")),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.form.options, (options, optionsIndex) => {
                return (_openBlock(), _createBlock("div", {
                  class: "list-items",
                  key: optionsIndex
                }, [
                  _createVNode("div", _hoisted_36, [
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      id: "",
                      name: "checkddd",
                      value: options.option,
                      "onUpdate:modelValue": ($event: any) => (options.selected = $event)
                    }, null, 8, ["value", "onUpdate:modelValue"]), [
                      [_vModelCheckbox, options.selected]
                    ]),
                    _createVNode("label", _hoisted_37, _toDisplayString(options.option), 1)
                  ])
                ]))
              }), 128))
            ]))
      ]))
    : _createCommentVNode("", true)
}